import { IPeriodConfiguration, TimeInterval, NameBuilderConfiguration, AggregationConfiguration } from '../../models/';
import { SeriesConfiguration } from '../../widgets';
import { ChartConfigurationOption } from '../../wtFramework';
import { IPresentationUnitConfiguration } from '../models/interfaces';

export class TagsTrendConfiguration implements IPeriodConfiguration {
    alignedOn: 0 | 1 | 2;
    series: SeriesConfiguration[];
    options: ChartConfigurationOption & IPresentationUnitConfiguration & {
        display?: {
            yMin?: number;
            yMax?: number;
        }
    };
    aggregation: AggregationConfiguration;
    minPeriod: TimeInterval;
    maxPeriod: TimeInterval;
    isEndDateIncluded = false;
    hideMissing: boolean;
    nameConfiguration: NameBuilderConfiguration;
    showLogbook: boolean;
    showAlarms: boolean;

    constructor() {
        this.series = [];
        this.options = new ChartConfigurationOption();
        this.aggregation = new AggregationConfiguration();
        this.hideMissing = false;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.nameConfiguration.hasUnit = true;
        this.alignedOn = 0;
    }
}